<mat-form-field appearance="fill" class="w-100" (click)="picker.open()">
  <mat-label>{{ label }}</mat-label>

  <input
    matInput
    [value]="value"
    [matDatepicker]="picker"
    [max]="maxDate"
    [placeholder]="placeholder"
    readonly
    (click)="picker.open()">

  <mat-datepicker-toggle
    matSuffix
    [for]="picker"
    (click)="picker.open()">
  </mat-datepicker-toggle>

  <mat-datepicker
    #picker
    startView="multi-year"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, picker)">
  </mat-datepicker>
</mat-form-field>